// extracted by mini-css-extract-plugin
export var askAiIcon = "_lx-j";
export var category = "_lx-9";
export var categoryHeader = "_lx-e";
export var container = "_lx-0";
export var group = "_lx-a";
export var groupItems = "_lx-f";
export var groupSeparator = "_lx-k";
export var loading = "_lx-1";
export var noResults = "_lx-3";
export var placeholder = "_lx-2";
export var resultContent = "_lx-5";
export var resultIcon = "_lx-c";
export var resultItem = "_lx-g";
export var resultMeta = "_lx-8";
export var resultSubtitle = "_lx-7";
export var resultSuffix = "_lx-i";
export var resultTitle = "_lx-6";
export var resultsList = "_lx-4";
export var searchGroup = "_lx-d";
export var selected = "_lx-h";
export var subgroup = "_lx-b";